// extracted by mini-css-extract-plugin
export default {"wrapper":"Empty_wrapper__FSUXM","host":"Empty_host__FccBd","buttons":"Empty_buttons__1aePc","header":"Empty_header__+67M5","subtitle":"Empty_subtitle__7PlJk"};